import { Button } from "@mui/material";

type ChatButtonType = "CONFIRM" | "DISCARD";

interface ChatButtonProps {
  label: string;
  level: string;
  type: ChatButtonType;
  onButtonClick: (type: ChatButtonType) => void;
}

export const ChatButton = ({
  label,
  level,
  type,
  onButtonClick,
}: ChatButtonProps) => {
  const variant = level === "primary" ? "contained" : "outlined";

  return (
    <Button
      variant={variant}
      size="small"
      onClick={() => onButtonClick(type)}
      sx={{
        mt: 1,
        mr: 1,
        mb: 1,
        textTransform: "none",
        fontSize: "0.875rem",
      }}
    >
      {label}
    </Button>
  );
};
